import { appConfigStore } from 'Models/AppConfigStore';
import { TabSelected } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/BookingWizardTypes';

export const useIsSoldOut = (bookingType: TabSelected, paxSpaces: number, vehicleSpaces: number) => {
	if (bookingType === 'freight' && appConfigStore.freightEnabled) {
		return false;
	}
	if (bookingType === 'vehicle') {
		if (vehicleSpaces < 1) {
			return true;
		}
		if (appConfigStore.minRequiredAdultsInVehicleBooking === 0) {
			// This means that passenger capacity does not affect vehicle availability.
			return false;
		}
	}

	return paxSpaces < 1;
};
